<template>
  <div
    class="translation_box"
    :style="{
      marginTop: content.textStyle.marginTop + 'rem' || '',
      marginBottom: content.textStyle.marginBottom + 'rem' || '',
    }"
  >
  <audio src="" id="audio_word"></audio>
    <div
      class="translation_box_left"
      :style="{
        color: content.content[0].textStyle.color || '',
        fontFamily: content.content[0].textStyle.fontFamily || '',
        fontSize: content.content[0].textStyle.fontSize + 'rem' || '',
        fontStyle:
          content.content[0].textStyle.fontItalic === 1 ? 'italic' : '',
      }"
    >
      {{ content.content[0].text }}
    </div>
    <div class="translation_box_right">
      <div
        v-for="(item, index) in content.content"
        :key="index"
        style="position: relative; height: 80rem; line-height: 80rem"
      >
        <span
          v-for="(ite, ind) in item.content"
          :key="ind"
          :style="{
            color: ite.textStyle.color || '',
            fontFamily: ite.textStyle.fontFamily || '',
            fontSize: ite.textStyle.fontSize + 'rem' || '',
            fontStyle: ite.textStyle.fontItalic === 1 ? 'italic' : '',
          }"
          >
            <template>
                <popover :key="item.key" v-if="item.category === 'popover'&&ind>0" :content="ite"></popover>
                <span v-if="item.category !== 'popover'">{{ ite.text }}</span>
            </template>
          </span
        >
        <img
          :src="
            !item.isPlay
              ? require('@/assets/images/books/book2/play_default.png')
              : require('@/assets/images/books/book2/play_process.png')
          "
          alt=""
          class="audio_img"
          @click="audioPlayClick(item)"
        />
      </div>
    </div>
  </div>
</template>
   
<script>
import Link from "../text/link.vue";
import popover from "../text/popover.vue";
export default {
  data() {
    return {};
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { popover },
  created() {},
  methods: {
    //音频播放点击
    audioPlayClick(item) {
      console.log(item);
      item.isPlay = !item.isPlay;
      if (item.isPlay) {
        var audio = document.getElementById("audio_word");
        audio.src = item.word_url;
        audio.play();
      } else {
        var audio = document.getElementById("audio_word");
        audio.pause();
      }
      audio.addEventListener("ended", function () {
        console.log("音频播放完成");
        item.isPlay = false;
      });
    },
  },
};
</script>
   
<style scoped lang='scss'>
.translation_box {
  width: calc(100% - 48rem);
  display: flex;
  margin: 0 auto;
  .translation_box_left {
    width: 48rem;
    height: 48rem;
    background: #b9d0ba;
    border-radius: 10rem 0 0 10rem;
    text-align: center;
  }
  .translation_box_right {
    flex: 1;
    border: 1rem solid #b9d0ba;
    border-radius: 0 10rem 10rem 10rem;
    background: #fff;
    padding: 11rem 21rem;
  }
}
.audio_img {
  position: absolute;
  width: 48rem;
  height: 48rem;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>